import script from "./submit_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./submit_modal.vue?vue&type=script&setup=true&lang=js"

import "./submit_modal.vue?vue&type=style&index=0&id=5177114e&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5177114e"]])

export default __exports__